"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utility_1 = require("../utility");
var rules = {
    msgSendRule: {
        type: "transfer",
        attributes: [["recipient"], ["sender"], ["amount"]],
    },
    msgWithdrawDelegationRewardRule: {
        type: "withdraw_rewards",
        attributes: [["amount"], ["validator"]],
    },
    msgVoteRule: {
        type: "proposal_vote",
        attributes: [["option"], ["proposal_id"]],
    },
    msgSubmitProposalRule: {
        type: "submit_proposal",
        attributes: [["proposal_id"], ["proposal_type"], ["voting_period_start"]],
    },
    msgDepositRule: {
        type: "proposal_deposit",
        attributes: [["amount"], ["proposal_id"]],
    },
    msgSwapRule: {
        type: "swap",
        attributes: [
            ["offer"],
            ["trader"],
            ["recipient"],
            ["swap_coin"],
            ["swap_fee"],
        ],
    },
    msgTerraSwapRule: {
        type: "from_contract",
        attributes: [
            ["offer_asset"],
            ["ask_asset"],
            ["offer_amount"],
            ["return_amount"],
            ["tax_amount"],
            ["spread_amount"],
            ["commission_amount"],
        ],
    },
    msgExchangeRateVoteRule: {
        type: "vote",
        attributes: [["denom"], ["voter"], ["exchange_rate"], ["feeder"]],
    },
    msgExchangeRatePrevoteRule: {
        type: "prevote",
        attributes: [["denom"], ["voter"], ["feeder"]],
    },
    msgAggregateExchangeRateVoteRule: {
        type: "aggregate_vote",
        attributes: [["voter"], ["exchange_rates"], ["feeder"]],
    },
    msgAggregateExchangeRatePrevoteRule: {
        type: "aggregate_prevote",
        attributes: [["voter"], ["feeder"]],
    },
    msgUnjailRule: {
        type: "message",
        attributes: [["action", "unjail"], ["module", "slashing"], ["sender"]],
    },
    msgUndelegateRule: {
        type: "unbond",
        attributes: [["validator"], ["amount"], ["completion_time"]],
    },
    msgEditValidatorRule: {
        type: "message",
        attributes: [
            ["action", "edit_validator"],
            ["module", "staking"],
            ["sender"],
        ],
    },
    msgDelegateRule: {
        type: "delegate",
        attributes: [["validator"], ["amount"]],
    },
    msgCreateValidatorRule: {
        type: "create_validator",
        attributes: [["validator"], ["amount"]],
    },
    msgBeginRedelegateRule: {
        type: "redelegate",
        attributes: [
            ["source_validator"],
            ["destination_validator"],
            ["amount"],
            ["completion_time"],
        ],
    },
    msgStoreCodeRule: {
        type: "store_code",
        attributes: [["sender"], ["code_id"]],
    },
    msgMigrateContractRule: {
        type: "migrate_contract",
        attributes: [["code_id"], ["contract_address"]],
    },
    msgInstantiateContractRule: {
        type: "instantiate_contract",
        attributes: [["owner"], ["code_id"], ["contract_address"]],
    },
    msgMultiSendRule: {
        type: "transfer",
        attributes: [["recipient"], ["amount"]],
    },
    msgGrantAuthorization: {
        type: "grant_authorization",
        attributes: [["grant_type"], ["granter"], ["grantee"]],
    },
};
var showVoteOption = function (string) {
    var voteOptions = ["Yes", "Abstain", "No", "NoWithVeto"];
    try {
        var vote = JSON.parse(string);
        var option = parseInt(vote.option);
        return voteOptions[option - 1];
    }
    catch (_a) {
        return string;
    }
};
var create = function () {
    var msgSendRuleSet = {
        rule: rules.msgSendRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/send",
            canonicalMsg: [
                "".concat(matched[1].value, " send ").concat(matched[2].value, " to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var msgWithdrawDelegationRewardRuleSet = {
        rule: rules.msgWithdrawDelegationRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/withdraw-delegation-reward",
            canonicalMsg: [
                matched[0].value
                    ? "Withdraw ".concat(matched[0].value, " from ").concat(matched[1].value)
                    : "Withdraw from ".concat(matched[1].value),
            ],
            payload: fragment,
        }); },
    };
    var msgVoteRuleSet = {
        rule: rules.msgVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/vote",
            canonicalMsg: [
                "Vote ".concat(showVoteOption(matched[0].value), " (Proposal ID: ").concat(matched[1].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var msgSubmitProposalRuleSet = {
        rule: rules.msgSubmitProposalRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/submit-proposal",
            canonicalMsg: ["Create proposal (Proposal ID: ".concat(matched[0].value, ")")],
            payload: fragment,
        }); },
    };
    var msgDepositRuleSet = {
        rule: rules.msgDepositRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/deposit",
            canonicalMsg: [
                "Deposit ".concat(matched[0].value, " (Proposal ID: ").concat(matched[1].value, ")"),
            ],
            payload: fragment,
        }); },
    };
    var msgSwapRuleSet = {
        rule: rules.msgSwapRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/swap",
            canonicalMsg: ["Swap ".concat(matched[0].value, " for ").concat(matched[3].value)],
            payload: fragment,
        }); },
    };
    var msgExchangeRateVoteRuleSet = {
        rule: rules.msgExchangeRateVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/exchange-rate-vote",
            canonicalMsg: ["Vote ".concat(matched[2].value, " for ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var msgExchangeRatePrevoteRuleRuleSet = {
        rule: rules.msgExchangeRatePrevoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/exchange-rate-prevote",
            canonicalMsg: ["Prevote for ".concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var msgAggregateExchangeRateVoteRuleSet = {
        rule: rules.msgAggregateExchangeRateVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/aggregate-exchange-rate-vote",
            canonicalMsg: ["Vote ".concat(matched[1].value)],
            payload: fragment,
        }); },
    };
    var msgAggregateExchangeRatePrevoteRuleSet = {
        rule: rules.msgAggregateExchangeRatePrevoteRule,
        transform: function (fragment) { return ({
            msgType: "terra/aggregate-exchange-rate-prevote",
            canonicalMsg: ["Prevote for all"],
            payload: fragment,
        }); },
    };
    var msgUnjailRuleSet = {
        rule: rules.msgUnjailRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/unjail",
            canonicalMsg: ["Unjail ".concat(matched[2].value)],
            payload: fragment,
        }); },
    };
    var msgUndelegateRuleSet = {
        rule: rules.msgUndelegateRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/undelegate",
            canonicalMsg: [
                "Undelegate ".concat((0, utility_1.attachDenom)(matched[1].value), " to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var msgEditValidatorRuleSet = {
        rule: rules.msgEditValidatorRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/edit-validator",
            canonicalMsg: ["Edit ".concat(matched[2].value)],
            payload: fragment,
        }); },
    };
    var msgDelegateRuleSet = {
        rule: rules.msgDelegateRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/delegate",
            canonicalMsg: [
                "Delegate ".concat((0, utility_1.attachDenom)(matched[1].value), " to ").concat(matched[0].value),
            ],
            payload: fragment,
        }); },
    };
    var msgCreateValidatorRuleSet = {
        rule: rules.msgCreateValidatorRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/create-validator",
            canonicalMsg: ["Create ".concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var msgBeginRedelegateRuleSet = {
        rule: rules.msgBeginRedelegateRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/begin-redelegate",
            canonicalMsg: [
                "Redelegate ".concat((0, utility_1.attachDenom)(matched[2].value), " to ").concat(matched[1].value),
            ],
            payload: fragment,
        }); },
    };
    var msgStoreCodeRuleSet = {
        rule: rules.msgStoreCodeRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/store-code",
            canonicalMsg: ["Store ".concat(matched[1].value)],
            payload: fragment,
        }); },
    };
    var msgMigrateContractRuleSet = {
        rule: rules.msgMigrateContractRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/migrate-contract",
            canonicalMsg: ["Migrate ".concat(matched[1].value, " to code ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var msgInstantiateContractRuleSet = {
        rule: rules.msgInstantiateContractRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/instantiate-contract",
            canonicalMsg: [
                "Instantiate ".concat(matched[2].value, " from code ").concat(matched[1].value),
            ],
            payload: fragment,
        }); },
    };
    var msgTerraSwapRuleSet = {
        rule: rules.msgTerraSwapRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/swap",
            canonicalMsg: [
                "Swap ".concat(matched[2].value).concat(matched[0].value, " for ").concat(matched[3].value).concat(matched[1].value),
            ],
            payload: fragment,
        }); },
    };
    var msgMultiSendRuleSet = {
        rule: rules.msgMultiSendRule,
        transform: function (fragment, matched) { return ({
            msgType: "terra/multi-send",
            canonicalMsg: ["Send ".concat(matched[1].value, " to ").concat(matched[0].value)],
            payload: fragment,
        }); },
    };
    var msgGrantAuthorizationRuleSet = {
        rule: rules.msgGrantAuthorization,
        transform: function (fragment, matched) { return ({
            msgType: "terra/grant-authorization",
            canonicalMsg: [
                "Authorization for ".concat(matched[0].value, " granted to ").concat(matched[2].value),
            ],
            payload: fragment,
        }); },
    };
    return [
        msgSendRuleSet,
        msgWithdrawDelegationRewardRuleSet,
        msgVoteRuleSet,
        msgSubmitProposalRuleSet,
        msgDepositRuleSet,
        msgSwapRuleSet,
        msgExchangeRateVoteRuleSet,
        msgExchangeRatePrevoteRuleRuleSet,
        msgAggregateExchangeRateVoteRuleSet,
        msgAggregateExchangeRatePrevoteRuleSet,
        msgUnjailRuleSet,
        msgUndelegateRuleSet,
        msgEditValidatorRuleSet,
        msgDelegateRuleSet,
        msgCreateValidatorRuleSet,
        msgBeginRedelegateRuleSet,
        msgStoreCodeRuleSet,
        msgMigrateContractRuleSet,
        msgInstantiateContractRuleSet,
        msgTerraSwapRuleSet,
        msgMultiSendRuleSet,
        msgGrantAuthorizationRuleSet,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map